import { motion } from "framer-motion";

export const Ed = ({ text, goldItalic = true, className = "" }) => {
  const parts = String(text).split("*");
  return (
    <span className={className}>
      {parts.map((p, i) =>
        i % 2 === 1 ? (
          <em key={i} className={`font-serif italic font-medium ${goldItalic ? "text-[#C5A059]" : ""}`}>
            {p}
          </em>
        ) : (
          <span key={i}>{p}</span>
        )
      )}
    </span>
  );
};

export const Reveal = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
